import {
    LOADING_LIQUIDACIONES,
    LOADING_ORDENES_LIQUIDACION,
    LOADING_NOVEDADES_LIQUIDACION,
    LOADING_LOGISTICA_LIQUIDACION,
    FETCH_ACCIONES_LIQUIDACIONES,
    FETCH_ESTADOS_LIQUIDACIONES,
    FETCH_RESULTADOS_LIQUIDACIONES,
    FETCH_ACCION_LIQUIDACION_COMBO,
    FETCH_LIQUIDACIONES_BUSQUEDA,
    FETCH_LIQUIDACION_POR_ID,
    FETCH_LIQUIDACION_POR_ID_ORDENES,
    FETCH_LIQUIDACION_POR_ID_NOVEDADES,
    FETCH_LIQUIDACION_POR_ID_LOGISTICA,
    FETCH_ORDENES_PARA_NUEVA_LIQUIDACION,
    FETCH_NOVEDADES_PARA_NUEVA_LIQUIDACION,
    LIMPIAR_LIQUIDACIONES_BUSQUEDA,
    SET_FILTRO_LIQUIDACIONES,
    RESET_FILTRO_LIQUIDACIONES,
    RESET_LIQUIDACIONES,
    UPDATE_LIST_LIQUIDACIONES,
    UPDATE_ESTADO_LIQUIDACION,
    FETCH_DETALLE_RETENCIONES,
    FETCH_DETALLE_PERCEPCIONES,
    RESET_PERCEPCION_RETENCION_LIQUIDACION,
    SET_PERCEPCION_RETENCION,
    UPDATE_CUERPO_ORDENES_LIQUIDACION,
    LOADING_DETALLE_LIQUIDACION,
    LOADING_DETALLE_RETENCIONES
} from './types';

import {
    getAccionesLiquidaciones,
    getEstadosLiquidaciones,
    getResultadosLiquidaciones,
    getLiquidacionesBusqueda,
    getLiquidacionporid,
    getLiquidacionPorIdOrdenes,
    getLiquidacionPorIdNovedades,
    getLogistica,
    getOrdenesParaNuevaLiquidacion,
    getNovedadesParaNuevaLiquidacion,
    getDetallesRetenciones,
    postCalcularPercepcionRetencionApi
} from '../api/axios';

const toArray = (data) => {
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.elementos)) return data.elementos;
    if (Array.isArray(data?.Elementos)) return data.Elementos;
    if (Array.isArray(data?.content)) return data.content;
    if (Array.isArray(data?.Content)) return data.Content;
    if (Array.isArray(data?.data)) return data.data;
    return [];
};


export const fetchAccionesLiquidaciones = () => async dispatch => {
    let array = getAccionesLiquidaciones();
    array.then((value) => {
        const payload = Array.isArray(value?.listadoNovedadesSubtipo)
            ? value.listadoNovedadesSubtipo
            : Array.isArray(value?.subTiposNovedades)
                ? value.subTiposNovedades
            : toArray(value);
        dispatch({
            type: FETCH_ACCIONES_LIQUIDACIONES,
            payload
        });
    })
}

export const fetchEstadosLiquidaciones = () => async dispatch => {
    let array = getEstadosLiquidaciones();
    array.then((value) => {
        const payload = Array.isArray(value?.listadoEstadosNovedades)
            ? value.listadoEstadosNovedades
            : Array.isArray(value?.estados)
                ? value.estados
                : Array.isArray(value?.Estados)
                    ? value.Estados
                    : toArray(value);
        dispatch({
            type: FETCH_ESTADOS_LIQUIDACIONES,
            payload
        });
    })
}

export const comboAccionLiquidacion = (accion) => dispatch => {
    dispatch({
        type: FETCH_ACCION_LIQUIDACION_COMBO,
        payload: accion
    });
}

export const fetchResultadosLiquidaciones = (request) => async dispatch => {

    dispatch({
        type: LOADING_LIQUIDACIONES,
        payload: true
    });

    let novedades = getResultadosLiquidaciones(request);

    novedades.then(function (value) {

        dispatch({
            type: LOADING_LIQUIDACIONES,
            payload: false
        });

        const payload = Array.isArray(value?.novedades)
            ? value.novedades
            : toArray(value?.novedades ?? value);
        dispatch({
            type: FETCH_RESULTADOS_LIQUIDACIONES,
            payload
        });
    });
}

const parseIdLiquidacionFromRequest = (req) => {
    const raw = req?.idLiquidacion ?? req?.IdLiquidacion;
    if (raw === '' || raw === undefined || raw === null) return null;
    const n = typeof raw === 'number' ? raw : parseInt(String(raw).trim(), 10);
    return Number.isNaN(n) || n < 1 ? null : n;
};

const normalizeLiquidacionesBusquedaPayload = (value, request) => {
    const req = request || {};
    const numeroPagina = Number(req.numeroPagina ?? req.NumeroPagina ?? 1) || 1;
    const tamanoPagina = Number(req.tamanoPagina ?? req.TamanoPagina ?? req.cantidadPagina ?? req.CantidadPagina ?? 10) || 10;
    const v = value || {};
    let lista = Array.isArray(v.encabezado)
        ? v.encabezado
        : Array.isArray(v.Encabezado)
            ? v.Encabezado
            : [];

    const idBuscado = parseIdLiquidacionFromRequest(req);
    if (idBuscado != null) {
        lista = lista.filter((item) => {
            const id = item.idLiquidacion ?? item.IdLiquidacion;
            return Number(id) === idBuscado;
        });
        return { lista, cantidadTotal: lista.length };
    }

    const lenAntesSlice = lista.length;
    lista = lista.slice(0, tamanoPagina);

    let cantidadTotal = v.cantidadTotal ?? v.CantidadTotal ?? v.totalRegistros ?? v.TotalRegistros
        ?? v.total ?? v.Total ?? v.cantidadRegistros ?? v.CantidadRegistros
        ?? v.totalItems ?? v.TotalItems;
    if (cantidadTotal == null || cantidadTotal === '' || Number.isNaN(Number(cantidadTotal))) {
        if (lenAntesSlice < tamanoPagina) {
            cantidadTotal = (Math.max(1, numeroPagina) - 1) * tamanoPagina + lenAntesSlice;
        } else {
            cantidadTotal = numeroPagina * tamanoPagina + 1;
        }
    }
    return { lista, cantidadTotal: Number(cantidadTotal) };
};

export const fetchLiquidacionesBusqueda = (request) => async dispatch => {
    dispatch({
        type: LOADING_LIQUIDACIONES,
        payload: true
    });

    let array = getLiquidacionesBusqueda(request);
    array.then((value) => {

        dispatch({
            type: LOADING_LIQUIDACIONES,
            payload: false
        });

        dispatch({
            type: FETCH_LIQUIDACIONES_BUSQUEDA,
            payload: normalizeLiquidacionesBusquedaPayload(value, request)
        });
    }).catch(() => {
        dispatch({
            type: LOADING_LIQUIDACIONES,
            payload: false
        });
        dispatch({
            type: FETCH_LIQUIDACIONES_BUSQUEDA,
            payload: { lista: [], cantidadTotal: 0 }
        });
    });
}

export const limpiarLiquidacionesBusqueda = () => dispatch => {

    dispatch({
        type: LIMPIAR_LIQUIDACIONES_BUSQUEDA,
        payload: []

    });
}

export const fetchLiquidacionporid = (request) => async dispatch => {
    let array = getLiquidacionporid(request);
    
    dispatch({
        type: LOADING_DETALLE_LIQUIDACION,
        payload: true
    });
    array.then((value) => {
        const v = value ?? {};
        const normalized = {
            ...v,
            encabezadoLiquidacion: v?.encabezadoLiquidacion ?? v?.EncabezadoLiquidacion ?? {},
            cuerpoOrdenLiquidaciones: v?.cuerpoOrdenLiquidaciones ?? v?.CuerpoOrdenLiquidaciones ?? [],
            cuerpoFeeLogisticoLiquidaciones: v?.cuerpoFeeLogisticoLiquidaciones ?? v?.CuerpoFeeLogisticoLiquidaciones ?? [],
            cuerpoNovedadLiquidaciones: v?.cuerpoNovedadLiquidaciones ?? v?.CuerpoNovedadLiquidaciones ?? [],
            detalleRebate: v?.detalleRebate ?? v?.DetalleRebate ?? []
        };

        dispatch({
            type: FETCH_LIQUIDACION_POR_ID,
            payload: normalized
        });
         dispatch({
        type: LOADING_DETALLE_LIQUIDACION,
        payload: false
        });
    }).catch(() => {
        dispatch({
            type: FETCH_LIQUIDACION_POR_ID,
            payload: {
                encabezadoLiquidacion: {},
                cuerpoOrdenLiquidaciones: [],
                cuerpoFeeLogisticoLiquidaciones: [],
                cuerpoNovedadLiquidaciones: [],
                detalleRebate: []
            }
        });
        dispatch({
            type: LOADING_DETALLE_LIQUIDACION,
            payload: false
        });
    });
};



export const fetchLiquidacionporidOrdenes = (request) => async dispatch => {

    dispatch({
        type: LOADING_ORDENES_LIQUIDACION,
        payload: true
    });

    let array = getLiquidacionPorIdOrdenes(request);
    array.then((value) => {
        dispatch({
            type: LOADING_ORDENES_LIQUIDACION,
            payload: false
        });
        dispatch({
            type: FETCH_LIQUIDACION_POR_ID_ORDENES,
            payload: value.ordenes
        });
    })
}

export const fetchLiquidacionporidNovedades = (request) => async dispatch => {

    dispatch({
        type: LOADING_NOVEDADES_LIQUIDACION,
        payload: true
    });

    let array = getLiquidacionPorIdNovedades(request);
    array.then((value) => {
        dispatch({
            type: FETCH_LIQUIDACION_POR_ID_NOVEDADES,
            payload: value.novedadesDeLiquidacion
        });

        dispatch({
            type: LOADING_NOVEDADES_LIQUIDACION,
            payload: false
        });
    })
}

export const fetchLiquidacionporidLogistica = (request) => async dispatch => {
    let requestUpdate = { idLiquidacion: [request.idLiquidacion] }

    dispatch({
        type: LOADING_LOGISTICA_LIQUIDACION,
        payload: true
    });

    let array = getLogistica(requestUpdate);
    array.then((value) => {

        dispatch({
            type: FETCH_LIQUIDACION_POR_ID_LOGISTICA,
            payload: value.datosFee
        });

        dispatch({
            type: LOADING_LOGISTICA_LIQUIDACION,
            payload: false
        });
    })
}

export const fetchOrdenesParaNuevaLiquidacion = (request) => async dispatch => {

    dispatch({
        type: LOADING_ORDENES_LIQUIDACION,
        payload: true
    });

    let res = getOrdenesParaNuevaLiquidacion(request);

    res.then((data) => {
        const lista = data?.ordenes ?? data?.ordenesAptasParaLiquidar;
        dispatch({
            type: FETCH_ORDENES_PARA_NUEVA_LIQUIDACION,
            payload: Array.isArray(lista) ? lista : []
        });

        dispatch({
            type: LOADING_ORDENES_LIQUIDACION,
            payload: false
        });
    });
}

export const fetchNovedadesParaNuevaLiquidacion = (request) => async dispatch => {

    dispatch({
        type: LOADING_NOVEDADES_LIQUIDACION,
        payload: true
    });

    let res = getNovedadesParaNuevaLiquidacion(request);
    res.then((liquidacion) => {
        const lista = liquidacion?.novedades;
        dispatch({
            type: FETCH_NOVEDADES_PARA_NUEVA_LIQUIDACION,
            payload: Array.isArray(lista) ? lista : []
        });

        dispatch({
            type: LOADING_NOVEDADES_LIQUIDACION,
            payload: false
        });
    })
}

export const setFiltroLiquidaciones = (filtro) => async dispatch => {
    dispatch({
        type: SET_FILTRO_LIQUIDACIONES,
        payload: filtro
    });
};

export const resetFiltroLiquidaciones = () => async dispatch => {
    dispatch({
        type: RESET_FILTRO_LIQUIDACIONES,
        payload: []
    });
};

export const resetLiquidaciones = () => async dispatch => {
    dispatch({
        type: RESET_LIQUIDACIONES,
        payload: []
    })
};

export const updateLiquidaciones = (liquidacionesArray, idLiquidacion) => async dispatch => {
    const liquidacionesActualizadas = liquidacionesArray.filter(item => item.idLiquidacion !== idLiquidacion);
    dispatch({
        type: UPDATE_LIST_LIQUIDACIONES,
        payload: liquidacionesActualizadas
    });
};


export const updateEstadoLiquidacion = (liquidacion) => async (dispatch) => {
    const nuevoEstadoLiquidacion = {
        ...liquidacion,
    };
    dispatch({
        type: UPDATE_ESTADO_LIQUIDACION,
        payload: nuevoEstadoLiquidacion,
    });
};

export const updateEstadoListLiquidacion = (liquidaciones, id) => async (dispatch) => {
    const idNumber = Number(id); 
   const elementos = liquidaciones.map(item => {
        if (item.idLiquidacion === idNumber) {
            return {
                ...item,
                idTipoEstadoLiquidacion: 3
            };
        }
        return item;
    });

    const modificado = elementos.find(e => e.idLiquidacion === idNumber);
    dispatch({
        type: UPDATE_LIST_LIQUIDACIONES,
        payload: elementos,
    });
};

export const fetchDetalleRetenciones = (idLiquidacion) => async (dispatch) => {
    dispatch({
        type: LOADING_DETALLE_RETENCIONES,
        payload: true
    });

    try {
        const res = await getDetallesRetenciones(idLiquidacion);
        const detalleTributarioOrdenes = res?.data?.detalleTributarioOrdenes ?? [];
        const detalleTributarioLiquidacion = res?.data?.detalleTributarioLiquidacion ?? [];

        dispatch({
            type: FETCH_DETALLE_RETENCIONES,
            payload: {
                detalleTributarioOrdenes,
                detalleTributarioLiquidacion
            }
        });
    } catch (error) {
        console.error("Error al obtener detalles de retenciones/percepciones", error);
    } finally {
        dispatch({
            type: LOADING_DETALLE_RETENCIONES,
            payload: false
        });
    }
};

export const resetPercepcionRetencionLiquidacion = () => async dispatch => {
    dispatch({
        type: RESET_PERCEPCION_RETENCION_LIQUIDACION,
        payload: []
    })
};

export const fetchCalcularPercepcionRetencion = (request) => async (dispatch) => {
    try {
        const response = await postCalcularPercepcionRetencionApi(request);
        dispatch({
            type: SET_PERCEPCION_RETENCION,
            payload: response // puede tener { retenciones, totalRetenciones, totalPercepcion }
        });
        return response;
    } catch (error) {
        throw error;
    }
};


export const actualizarTotalRetencionesOrdenes = (retenciones, ordenesOriginales = null) => (dispatch, getState) => {
    const ordenes = ordenesOriginales || getState().liquidaciones.cuerpoOrdenLiquidaciones;

    const nuevasOrdenes = ordenes.map(orden => {
        const match = retenciones?.find(r => r.idVenta === orden.idOrden);

        if (match) {
            return {
                ...orden,
                retencion: match?.totalRetencion ?? 0,
                //totalRetencion: match.totalRetencion
            };
        }

        return orden; 
    });

    dispatch({
        type: UPDATE_CUERPO_ORDENES_LIQUIDACION,
        payload: nuevasOrdenes
    });
};